import { FC } from 'react';
import { WrapInLayout } from '../layouts';
import RolesForm from '../components/roles/RolesForm';

const RolesPage: FC = () => {
  return (
    <WrapInLayout title="Roles" layout="portal">
      <RolesForm />
    </WrapInLayout>
  );
};

export default RolesPage;
